// Check number
export function numberValidation(e) {
  // Accept Float Number
  return /^[+-]?\d+(\.\d+)?$/.test(e);
}
